import { render, staticRenderFns } from "./edit-returnorder.vue?vue&type=template&id=45fe6629&"
import script from "./edit-returnorder.vue?vue&type=script&lang=ts&"
export * from "./edit-returnorder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports